import initHeader from './layout/header.js';
import initModals from './layout/modals.js';

jQuery(document).ready(function ($) {
  initHeader();
  initModals();
  gsap.registerPlugin(ScrollTrigger);

  /*smooth scroll safari*/
  document.addEventListener("DOMContentLoaded", function () {
    // 1. Store hash if it exists
    const hash = window.location.hash;

    if (hash) {
      // 2. Scroll instantly to top to prevent native jump
      window.scrollTo(0, 0);

      // 3. Wait for page to fully render, then scroll smoothly
      setTimeout(function () {
        const target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }
      }, 300); // tweak this if needed
    }

    // 4. Smooth scroll for all in-page anchor clicks
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href");
        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          history.pushState(null, null, targetId);
          target.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  });
  /*smooth scroll safari*/

  let mediaQuery = window.matchMedia('(min-width: 992px)');


  gsap.utils.toArray('.fade-in-on-scroll').forEach((elem) => {
    gsap.from(elem, {
      opacity: 0,
      y: 50,  // Element starts 50px lower
      duration: 1, // Duration of the animation
      ease: 'power2.out', // Easing for smoothness
      scrollTrigger: {
        trigger: elem, // The element itself
        start: 'top 80%',  // When the element hits 80% of the viewport
        end: 'bottom top', // When the bottom of the element leaves the viewport
        scrub: true,  // Smooth animation that follows the scroll position
        toggleActions: 'play none none none' // Play animation once when it comes into view
      }
    });
  });

  if (typeof wp !== 'undefined' && wp.domReady) {
    wp.domReady(function () {
      setTimeout(function () {
        gsapAnimation();
        if (mediaQuery.matches) {
          paralax();  // Call paralax only if the screen width is greater than 991px
        }
      }, 500); // Delay after the DOM is ready
    });
  } else {
    gsapAnimation();
    if (mediaQuery.matches) {
      paralax();  // Call paralax only if the screen width is greater than 991px
    }
  }

  // Hero section animation
  function gsapAnimation() {
    gsap.to('.word', {
      opacity: 1,
      y: 0,
      duration: 2,
      ease: 'power2.out',
      stagger: {
        each: 0.5,
      },
    });

  }

  // Parallax effect
  function paralax() {
    gsap.to('.first-paralax', {
      y: -300, // Moves 200px down (slower parallax)
      scrollTrigger: {
        trigger: '.paralax-container',
        start: 'top 80%',
        end: 'bottom top',
        scrub: 2, // Slower scroll speed (animation follows scroll slower)
      },
    });

    gsap.to('.last-paralax', {
      y: 300, // Moves 150px up (faster parallax)
      scrollTrigger: {
        trigger: '.paralax-container',
        start: 'top 80%',
        end: 'bottom top',
        scrub: 1, // Faster scroll speed (animation follows scroll faster)
      },
    });
  }

  window.addEventListener('load', function () {
    ScrollTrigger.refresh(); // Forces ScrollTrigger to recalculate positions
    gsapAnimation(); // Ensure animations are triggered
    if (mediaQuery.matches) {
      paralax(); // Call paralax only if the screen width is greater than 991px
    }
  });

  gsap.defaults({
    ease: 'power4.out',
    duration: 0.25,
  });

  const cursor = document.querySelector('.cursor');
  if (cursor) {
    const xSet = gsap.quickSetter(cursor, 'x', 'px');
    const ySet = gsap.quickSetter(cursor, 'y', 'px');

    window.addEventListener('pointermove', (e) => {
      if (e.pointerType === 'touch') {
        gsap.to(cursor, { autoAlpha: 0 });
      } else {
        gsap.to(cursor, { autoAlpha: 1 });
        xSet(e.clientX);
        ySet(e.clientY);
      }
    });

    const interactiveElements = document.querySelectorAll(
        'a, button, input[type="submit"], [role="button"], .clickable, [class*="button"]'
    );

    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
    });

    document.addEventListener('mouseleave', () => {
      gsap.to(cursor, { autoAlpha: 0 });
    });

    document.addEventListener('mousedown', () => {
      gsap.to(cursor, { scale: 0.8, duration: 0.1 });
    });

    document.addEventListener('mouseup', () => {
      gsap.to(cursor, { scale: 1 });
    });
  }
});
